// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 오른쪽 패널 제목줄 — **모양의 단일 정의**(components/common/PanelHeader.js).
   패널마다 따로 칠하지 말 것. 세 벌이 조금씩 달라 "일관되지 않다" 는 지적을 받았다(2026-09-20). */

.panel-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 10px;
  background: var(--color-bg-secondary, #f5f6f8);
  border-bottom: 1px solid var(--color-border, #e0e0e0);
  color: var(--color-text, #1f2937);
  flex-shrink: 0;
}

.panel-header-icon {
  display: inline-flex;
  align-items: center;
  color: var(--color-text-secondary, #6b7280);
}

/* 자리가 모자라면 제목이 줄어든다 — 동작 버튼과 닫기가 밀려나면 안 된다. */
.panel-header-title {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
  font-size: 12px;
}

/* 패널마다 다른 동작 버튼(쿼리 작성·분석 조회 등)의 공통 모양 */
.panel-header-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid var(--color-border, #d0d5dd);
  border-radius: 3px;
  background: var(--color-bg, #fff);
  color: var(--color-text, #1f2937);
  font-size: 11px;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
  cursor: pointer;
  white-space: nowrap;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}
.panel-header-action:hover:not(:disabled) {
  border-color: var(--color-accent, #3b82f6);
  color: var(--color-accent, #3b82f6);
}
.panel-header-action:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.panel-header-close {
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  border-radius: 3px;
  padding: 2px 4px;
  cursor: pointer;
  color: var(--color-text-secondary, #6b7280);
  transition: background 150ms ease, color 150ms ease;
}
.panel-header-close:hover {
  background: var(--color-hover, rgba(0, 0, 0, 0.06));
  color: var(--color-text, #1f2937);
}

@media (prefers-reduced-motion: reduce) {
  .panel-header-action,
  .panel-header-close { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/PanelHeader.css"],"names":[],"mappings":"AAAA;kEACkE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,8CAA8C;EAC9C,qDAAqD;EACrD,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,8CAA8C;AAC9C;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,eAAe;EACf,mDAAmD;EACnD,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;AACA;EACE,0CAA0C;EAC1C,mCAAmC;AACrC;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,mDAAmD;AACrD;AACA;EACE,mDAAmD;EACnD,iCAAiC;AACnC;;AAEA;EACE;wBACsB,gBAAgB,EAAE;AAC1C","sourcesContent":["/* 오른쪽 패널 제목줄 — **모양의 단일 정의**(components/common/PanelHeader.js).\n   패널마다 따로 칠하지 말 것. 세 벌이 조금씩 달라 \"일관되지 않다\" 는 지적을 받았다(2026-09-20). */\n\n.panel-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 10px;\n  background: var(--color-bg-secondary, #f5f6f8);\n  border-bottom: 1px solid var(--color-border, #e0e0e0);\n  color: var(--color-text, #1f2937);\n  flex-shrink: 0;\n}\n\n.panel-header-icon {\n  display: inline-flex;\n  align-items: center;\n  color: var(--color-text-secondary, #6b7280);\n}\n\n/* 자리가 모자라면 제목이 줄어든다 — 동작 버튼과 닫기가 밀려나면 안 된다. */\n.panel-header-title {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* 패널마다 다른 동작 버튼(쿼리 작성·분석 조회 등)의 공통 모양 */\n.panel-header-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 3px 8px;\n  border: 1px solid var(--color-border, #d0d5dd);\n  border-radius: 3px;\n  background: var(--color-bg, #fff);\n  color: var(--color-text, #1f2937);\n  font-size: 11px;\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n.panel-header-action:hover:not(:disabled) {\n  border-color: var(--color-accent, #3b82f6);\n  color: var(--color-accent, #3b82f6);\n}\n.panel-header-action:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.panel-header-close {\n  display: inline-flex;\n  align-items: center;\n  background: none;\n  border: none;\n  border-radius: 3px;\n  padding: 2px 4px;\n  cursor: pointer;\n  color: var(--color-text-secondary, #6b7280);\n  transition: background 150ms ease, color 150ms ease;\n}\n.panel-header-close:hover {\n  background: var(--color-hover, rgba(0, 0, 0, 0.06));\n  color: var(--color-text, #1f2937);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .panel-header-action,\n  .panel-header-close { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
